/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_App_Block_TitleInputs */

const en_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block 50 interruptive apps`)
};

const ar_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حظر 50 تطبيقًا مزعجًا`)
};

const de_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockiere 50 störende Apps`)
};

const es_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquea 50 apps que interrumpen`)
};

const fr_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquez 50 applications intrusives`)
};

const it_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocca 50 app che interrompono`)
};

const ja_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邪魔なアプリを50個ブロック`)
};

const ko_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방해 앱 50개 차단`)
};

const pt_br_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquear 50 apps que interrompem`)
};

const ru_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заблокировать 50 отвлекающих приложений`)
};

const th_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บล็อก 50 แอปที่รบกวน`)
};

const tr_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50 dikkat dağıtan uygulamayı engelle`)
};

const zh_cn_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阻挡 50 个干扰软件`)
};

const zh_tw_subscription_exclusive_feature_app_block_title = /** @type {(inputs: Subscription_Exclusive_Feature_App_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阻擋 50 個干擾 App`)
};

/**
* | output |
* | --- |
* | "Block 50 interruptive apps" |
*
* @param {Subscription_Exclusive_Feature_App_Block_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_app_block_title = /** @type {((inputs?: Subscription_Exclusive_Feature_App_Block_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_App_Block_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_app_block_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_app_block_title(inputs)
	return zh_tw_subscription_exclusive_feature_app_block_title(inputs)
});